import React, {Component} from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';
import Checkbox from 'rc-checkbox';

//import components

//img
import info from '../../assets/icons/info.svg';
import infoContrast from '../../assets/icons/info-contrast.svg';

class SelectedFilters extends Component {
    constructor(props) {
      	super(props);
        this.state = { isOpened: false };
    };

    mouseOut() {
        this.setState({isOpened: false});
    };

    mouseOver() {
        this.setState({isOpened: true});
    };

    rememberFiltersChange(e) {
        const {setIsBlocked} = this.props;
        setIsBlocked(e.target.checked);
    };

    render() {
        const {clang, newData, removeFilter, cleanAllFilters, rememberOption, isBlocked} = this.props;
        const {isOpened} = this.state;

        return (
            <div className="selected-filters">
                <div className="selected-filters__header-container">
                    <p className="selected-filters__header">
                        {lang[clang].results.chosen_filters}:
                    </p>
                    {rememberOption &&
                        <label className="selected-filters__block">
                            <Checkbox
                                className="selected-filters__block-checkbox"
                                prefixCls="checkbox--regular"
                                onChange={(e) => this.rememberFiltersChange(e)}
                                checked={isBlocked}/>
                            <span>{lang[clang].results.remember_filters}</span>
                            <div className="selected-filters__block__img-container"
                                onMouseOut={() => this.mouseOut()}
                                onMouseOver={() => this.mouseOver()}>
                                <img
                                    src={info}
                                    alt={lang[clang].alt.info}
                                    className="selected-filters__block__img"/>
                                <img
                                    src={infoContrast}
                                    alt={lang[clang].alt.info}
                                    className="selected-filters__block__img contrast"/>
                                {isOpened &&
                                    <div className="selected-filters__block__info">
                                        {lang[clang].results.info}
                                    </div>}
                            </div>
                        </label>}
                </div>
                {newData.map((filter, index) => <div key={index} className="selected-filters__filter-container">
                                                    {filter.label &&
                                                        <label className="selected-filters__filter-label">
                                                            {lang[clang].filter_labels[filter.label]}:
                                                        </label>}
                                                    {filter.value.map( (e, index) =>
                                                        <div key={index} className="selected-filters__filter">
                                                            <button
                                                                className="selected-filters__filter-remove"
                                                                title={lang[clang].results.delete_value}
                                                                onClick={() => removeFilter(e.id, filter.label)}>
                                                                <span className="selected-filters__filter-name" dangerouslySetInnerHTML={{__html: e.label}}></span>
                                                                <span className="selected-filters__filter-remove__img"></span>
                                                            </button>
                                                        </div>)}
                                                </div>)}
                <button onClick={() => cleanAllFilters()}
                    className="selected-filters__remove-all"
                    title={lang[clang].results.clear_filters}>
                      {lang[clang].results.clear_filters}
                </button>
            </div>
        );
    };
};

SelectedFilters.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(SelectedFilters);



// WEBPACK FOOTER //
// ./src/components/selected-filters/SelectedFilters.js